export const formatNumber = (value: number): string => {
  if (value >= 100000) {
    return `${(value / 10000).toFixed(1)} 万`;
  }
  if (value >= 10000) {
    return `${(value / 10000).toFixed(2)} 万`;
  }
  return value.toLocaleString("zh-CN");
};

export const formatDate = (value: string): string => {
  const parts = value.split("-");
  if (parts.length !== 3) return value;
  return `${parts[0]} 年 ${Number(parts[1])} 月 ${Number(parts[2])} 日`;
};